import { render, staticRenderFns } from "./SurveyExtraQuestionModal.vue?vue&type=template&id=504bba6f&"
import script from "./SurveyExtraQuestionModal.vue?vue&type=script&lang=js&"
export * from "./SurveyExtraQuestionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports